export default "__VITE_ASSET__B7MJ91MR__"